import { coinsIcon } from '../../assets/icons/icons';

import './Tip.css';

const TIP_VALUES = [0, 5, 10, 15, 20];

/**
 * Componente CONTROLADO. El valor activo viene siempre de props
 * (tipPercentageOption desde App.jsx) y el click solo notifica.
 *
 * Antes era stateful con tipOptions local, lo que causaba que al
 * desmontarse (volver a productos) y remontarse (volver al carrito)
 * el estado visual se reseteara a 0% aunque App.jsx mantuviera el
 * valor seleccionado. Resultado: la UI mostraba "0%" pero el total
 * incluia propina.
 */
export default function Tip(props) {
  const { isTipEnable, currentValue = 0, updateTip } = props;

  if (!isTipEnable) return null;

  return (
    <div className='tip__container'>
      <div className='tip__title'>
        <img src={coinsIcon} alt="tip" />
        <h2>¿Desea agregar propina?</h2>
      </div>
      <div className='tip__option-container'>
        {TIP_VALUES.map((value) => (
          <button
            key={`tip-option-${value}`}
            className={`tip__option ${value === currentValue ? 'tip__option--active' : ''}`}
            onClick={() => updateTip(value)}
          >{value}%</button>
        ))}
      </div>
    </div>
  );
}